import { IDictionary } from "../common";

export class Key {
    id: string;
    bettingTypeId: string;
    specifier?: IDictionary<string>;
    isFavorite?: boolean;
    isLocked?: boolean;
    betBuilder?: boolean;
}